<template>
  <div class="radio">
    <div class="radioIcon icon"></div>
    <marquee
      onmouseover="this.stop()"
      onmouseout="this.start()"
      id="noticeLink"
      scrollamount="3"
      class="marquee page_font_color"
      ><span @click="seeMore()">{{ notice }}</span></marquee
    >
    <span class="see-more" @click="seeMore()"> 查看更多 >> </span>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: ["notice"],
  methods: {
    seeMore() {
      this.$emit("seeMore");
    },
  },
};
</script>

<style lang="scss" scoped>
.radio {
  display: flex;
  align-items: center;
  // width: 960px;
  .icon {
    margin-right: 5px;
    width: 16px;
    height: 14px;
  }
  .marquee {
    font-size: 12px;
    cursor: pointer;
  }
  .see-more {
    margin-left: 10px;
    padding-right: 17px;
    white-space: nowrap;
    font-size: 12px;
    color: #113153;
    cursor: pointer;
  }
}
[data-theme="brown"] {
  .radio .see-more {
    color: #fff;
  }
}
</style>
